// src/utils/mrpInventoryPivot.js
export const INVENTORY_PIVOT_EMPTY_TOKEN = "__EMPTY__";
export const INVENTORY_PIVOT_FILTER_KEYS = ["custCode", "retailSku", "productCode", "warehouse"];

export function buildInventoryPivotQuery(filters = {}) {
  const params = new URLSearchParams();
  INVENTORY_PIVOT_FILTER_KEYS.forEach((key) => {
    const values = Array.isArray(filters[key]) ? filters[key] : [];
    values
      .filter((value) => value !== undefined && value !== null)
      .forEach((value) => {
        if (value === INVENTORY_PIVOT_EMPTY_TOKEN) {
          params.append(key, INVENTORY_PIVOT_EMPTY_TOKEN);
          return;
        }
        const text = typeof value === "string" ? value.trim() : String(value);
        params.append(key, text || INVENTORY_PIVOT_EMPTY_TOKEN);
      });
  });
  const query = params.toString();
  return query ? `?${query}` : "";
}

export function parseInventoryPivotFilters(search = "") {
  const filters = {};
  const query = search ? (search.startsWith("?") ? search : `?${search}`) : "";
  const params = new URLSearchParams(query);
  INVENTORY_PIVOT_FILTER_KEYS.forEach((key) => {
    const values = params.getAll(key);
    const fallback = key.toLowerCase() !== key ? params.getAll(key.toLowerCase()) : [];
    const combined = [...values, ...fallback];
    const cleaned = combined
      .map((value) => {
        if (value === INVENTORY_PIVOT_EMPTY_TOKEN) return INVENTORY_PIVOT_EMPTY_TOKEN;
        if (value === undefined || value === null) return "";
        return value.trim();
      })
      .filter((value) => value !== "");
    if (cleaned.length) {
      filters[key] = cleaned;
    }
  });
  return filters;
}
